module.exports = __webpack_public_path__ + "Octopus-96x96.c5fbe17b7d3edd3be5534adafd39f5c4.hashedasset.png";